
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { PositionServiceViewModel } from "@tylertech/tyler-api-types";

/**
 * PositionService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PositionService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetPositions(): Promise<PositionServiceViewModel[]> {
        return this.$apiService.sendAuth("IPositionService/GetPositions");
    }
    GetPositionTypes(): Promise<string[]> {
        return this.$apiService.sendAuth("IPositionService/GetPositionTypes");
    }
}
